"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.TitlesDefault = void 0;
require("./TitlesDefault.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _renderObject = require("../../util/renderObject/renderObject");
var _Link = _interopRequireDefault(require("../Link/Link"));
var _Text = _interopRequireDefault(require("../Text/Text"));
var _TitlesDefaultCompact = _interopRequireDefault(require("../TitlesDefaultCompact/TitlesDefaultCompact"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * TitlesDefault component
 *
 * @method
 * @param { TitlesDefaultProps} props
 * @returns TitlesDefault
 */

const TitlesDefault = props => {
  const {
    countLabel,
    externalAction,
    headline,
    headlineTag = defaultProps.headlineTag,
    description,
    linkAction,
    subheadline,
    textAlignment,
    size,
    textColor = defaultProps.textColor
  } = props;
  if (!headline) {
    return null;
  }
  if (size === 'compact') {
    return /*#__PURE__*/_react.default.createElement(_TitlesDefaultCompact.default, props);
  }
  const hasAction = linkAction?.label || externalAction;
  const headlineStyle = textAlignment === 'center' ? 'title-xlg' : 'title-lg';
  const subHeadlineStyle = textAlignment === 'center' ? 'body-lg' : 'body';
  const descriptionTextColor = textColor === 'content-default' ? 'xsubtle' : textColor;
  const componentClassName = (0, _classnames.default)('pal-c-TitlesDefault', {
    [`pal-c-TitlesDefault__alignment--${textAlignment}`]: textAlignment
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName
  }, headline && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-TitlesDefault__content"
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: headlineStyle,
    htmlTag: headlineTag,
    textAlign: textAlignment,
    textColor: textColor,
    className: "pal-c-TitlesDefault__content--headline"
  }, headline), subheadline && /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: subHeadlineStyle,
    htmlTag: "p",
    textAlign: textAlignment,
    textColor: textColor,
    className: "pal-c-TitlesDefault__content--subheadline"
  }, subheadline), description && /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: subHeadlineStyle,
    htmlTag: "p",
    textAlign: textAlignment,
    textColor: descriptionTextColor,
    className: "pal-c-TitlesDefault__content--description"
  }, description), countLabel && /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: "body",
    htmlTag: "p",
    textAlign: textAlignment,
    textColor: descriptionTextColor,
    className: "pal-c-TitlesDefault__content--countLabel"
  }, countLabel)), hasAction && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-TitlesDefault__link"
  }, externalAction && (0, _renderObject.renderObject)(externalAction), !externalAction && /*#__PURE__*/_react.default.createElement(_Link.default, _extends({
    variant: "primary"
  }, linkAction))));
};

/**
 * Property type definitions
 * @typedef TitlesDefaultProps
 * @type {object}
 * @property {string} countLabel - Accepts count label
 * @property {object} externalAction - Accepts action object from web-site with business logic
 * @property {string} headline - Sets the headline text of the title
 * @property {string} headlineTag - Sets the headline text's tag
 * @property {object} linkAction - Accepts an object to render palette Link component as action. ( Palette use only )
 * @property {string} subheadline - Sets the subheadline text of the title
 * @property {string} description - Accepts description text to render below subheadline
 * @property {string} textAlignment - Sets the alignment of the title ( left or center )
 * @property {string} size - Sets the size of the overall component
 * @property {string} textColor - Sets the color of the title
 */
exports.TitlesDefault = TitlesDefault;
const propTypes = exports.propTypes = {
  /**
   * Accepts count label
   */
  countLabel: _propTypes.default.string,
  /**
   * Accepts action object from web-site with business logic
   */
  externalAction: _propTypes.default.object,
  /**
   * Sets the headline text of the title
   */
  headline: _propTypes.default.string,
  /**
   * Sets the headline text's tag
   */
  headlineTag: _propTypes.default.string,
  /**
   * Accepts an object to render palette Link component as action. ( Palette use only )
   */
  linkAction: _propTypes.default.object,
  /**
   * Sets the subheadline text of the title
   */
  subheadline: _propTypes.default.string,
  /**
   * Accepts description text to render below subheadline
   */
  description: _propTypes.default.string,
  /**
   * Sets the alignment of the title ( left or center )
   */
  textAlignment: _propTypes.default.string,
  /**
   * Sets the size of the overall component
   */
  size: _propTypes.default.string,
  /**
   * Sets the color of the title
   */
  textColor: _propTypes.default.oneOf(['content-default', 'content-knockout'])
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {string} headlineTag='h2' - sets default headline tag to h2.
 * @property {string} textColor='content-default' - sets default text color of the title to content-default
 */
const defaultProps = exports.defaultProps = {
  headlineTag: 'h2',
  textColor: 'content-default'
};
TitlesDefault.propTypes = propTypes;
var _default = exports.default = TitlesDefault;